import {
	AfterViewChecked,
	Component,
	HostListener,
	OnInit
} from '@angular/core';
import { Router, RouterState } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { FacadeService } from 'src/app/core/services/facade.service';
import { State } from 'src/app/shared/enums/state.enum';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Planning } from 'src/app/shared/models/planning';
import { Route } from 'src/app/shared/models/route';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import { Solution } from 'src/app/shared/models/solution';
import { DateUtils } from 'src/app/shared/utils/date-utils';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-routes',
	templateUrl: './list-routes.component.html',
	styleUrls: ['./list-routes.component.scss']
})
export class ListRoutesComponent implements OnInit {
	monthsFr = [
		'janv',
		'févr',
		'mars',
		'avr',
		'mai',
		'juin',
		'juill',
		'aout',
		'sept',
		'oct',
		'nov',
		'déc'
	];
	daysFr = [
		'Dimanche',
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi'
	];

	/**
	 * Période selectionner
	 */
	dateRange: { value: Date[] } = { value: null };

	/**
	 * Semaine selectionner
	 */
	weeknumber: { value: number } = { value: null };

	/**
	 * Annee selectionner
	 */
	yearnumber: { value: number } = { value: null };

	/**
	 * Creation de tournée possible
	 */
	isAddable = false;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	/**
	 * Liste des solutions récupérés
	 */
	listSolution: Solution[] = [];

	/**
	 * Liste des routes à afficher
	 */
	listRouteObjectWithDetails: {
		routes: Route[];
		employee: Employee;
		serviceCenter: ServiceCenter;
	}[] = [];

	/**
	 * Liste des planning à afficher
	 */
	listPlanning: Planning[] = [];

	/**
	 * Id de l'employee à filtrer
	 */
	selectedEmployeeId: number = -1;

	/**
	 * Liste des employee récupérer
	 */
	listEmployee: Employee[];

	/**
	 * Enum état d'une route
	 */
	routeState = State;

	routes: Route[];

	/**
	 * liste des états de tournées
	 */
	listState;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	queryParams: string;
	state: string = 'Tous';

	isMobile = false;
	screenWidth: number;

	constructor(
		private facade: FacadeService,
		private dateUtils: DateUtils,
		public router: Router
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.listState = ['En étude', 'En attente', 'En cours'];

		this.getEmployee();
	}

	/**
	 * Appel au back pour récupérer les employées
	 */
	getEmployee() {
		this.facade.employeeService.getAllActiveEmployees().subscribe((employees) => {
			this.listEmployee = employees;
		});
	}

	/**
	 * Appel au back pour récupérer les solutions d'une semaine donner
	 */
	getSolution() {
		let listYearAndWeek: { week: number; year: number }[] =
			this.dateUtils.getWeekAndYearListBetweenStartAndEnd(
				this.dateRange.value[0],
				this.dateRange.value[1]
			);

		this.listSolution = [];

		const listOfApiCalls$: Observable<any>[] = [];

		for (let yaw of listYearAndWeek) {
			listOfApiCalls$.push(
				this.facade.solutionService.getSolutionByYearAndWeekNumberForRouteListing(
					yaw.year,
					yaw.week
				)
			);
		}
		forkJoin(listOfApiCalls$).subscribe((result) => {
			this.listSolution = result as Solution[];
			this.filterRoutes();
		});
	}

	/**
	 * Filtre les routes à afficher en fonction de l'employee sélectionner et de l'état de la tournée
	 */
	filterRoutes() {
		this.selectedEmployeeId = parseInt(this.selectedEmployeeId.toString());
		this.state = 'Tous';
		this.listRouteObjectWithDetails = [];
		//const stateKey = this.router.url.split('/').pop();
		// this.state = this.mappingState[stateKey];
		if (this.listSolution) {
			this.listSolution.forEach((solution) => {
				if (solution.plannings && solution.plannings.length >= 1) {
					solution.plannings.forEach((planning) => {
						if (this.selectedEmployeeId === -1) {
							// //Filtre selon état de tournée
							//this.routes = planning.routes
							// .filter(
							// 	(el) => State[el.state] === this.state
							// );
							this.listRouteObjectWithDetails.push({
								routes: [...planning.routes],
								serviceCenter: solution.serviceCenter,
								employee: planning.employee
							});
						} else {
							if (planning?.employee?.id === this.selectedEmployeeId) {
								this.listRouteObjectWithDetails.push({
									routes: [...planning.routes],
									serviceCenter: solution.serviceCenter,
									employee: planning.employee
								});
							}
						}
					});
				}
			});
		}
	}

	filterRoutesState() {
		this.listRouteObjectWithDetails = [];
		this.selectedEmployeeId = -1;
		this.listSolution.forEach((solution) => {
			if (solution.plannings && solution.plannings.length >= 1) {
				solution.plannings.forEach((planning) => {
					if (this.state !== 'Tous') {
						//Filtre selon état de tournée
						this.routes = planning.routes.filter((el) => {
							return State[el.state] === this.state;
						});
						this.listRouteObjectWithDetails.push({
							routes: [...this.routes],
							serviceCenter: solution.serviceCenter,
							employee: planning.employee
						});
					} else {
						this.listRouteObjectWithDetails.push({
							routes: [...planning.routes],
							serviceCenter: solution.serviceCenter,
							employee: planning.employee
						});
					}
				});
			}
		});
	}

	getState(etat: string) {
		let stateUrl = '';
		switch (etat) {
			case State.UNDER_REVIEW:
				stateUrl = 'etude';
				break;
			case State.PENDING:
				stateUrl = 'attente';
				break;
			case State.IN_PROGRESS:
				stateUrl = 'en-cours';
				break;
			default:
				stateUrl = 'etude';
				break;
		}
		return stateUrl;
	}

	/**
	 * Méthode de changement de tri, si le paramètre (colonne) de tri est le même, change l'ordre de tri
	 * sinon change la colonne de tri
	 *
	 * @param str
	 */
	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	/**
	 * Changement de l'employee à afficher, appel le filtre des routes
	 * @param idEmployee
	 */
	changeSelectedEmployee(idEmployee: number) {
		this.selectedEmployeeId = parseInt(idEmployee.toString());
		this.filterRoutes();
	}

	/**
	 * Methode appeler par le selecteur de date
	 */
	updateDates() {
		this.getSolution();
	}

	calculTotal(listRoute: Route[], paramToCalc) {
		let sum = 0;
		for (let i = 0; i < listRoute.length; i++) {
			if (paramToCalc === 'dist') {
				sum += listRoute[i].plannedDistance;
			} else {
				sum += listRoute[i].plannedTime;
			}
		}
		if (paramToCalc === 'dist') {
			return sum / 1000;
		} else {
			return sum;
		}
	}

	getDateDay(date) {
		date = new Date(date);
		let dayDate = this.daysFr[date.getDay()];
		return dayDate;
	}
}
